import createClient from "openapi-fetch";
import type { paths } from "../../__definitions__/self-driving.changeengine.com-definitions";
import { serviceURL } from "../../utils/service-url";

export const selfDriving = createClient<paths>({
  baseUrl: serviceURL("self-driving"),
  headers: {
    "Content-Type": "application/json",
  },
});
